import { useEffect, useState } from "react";
import OverallHeadtoHead from "./OverallHeadtoHead";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { league } from "../../../redux/actions";
import RaceweekHeadtoHead from "./RaceweekHeadtoHead";

const HeadToHead = () => {
  const { leagueId } = useParams();
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const leagueState = useSelector((state) => state.league);

  const userGuid = userState?.data?.GUID;
  const { selectedLeague } = leagueState;
  const [headToHeadViewGamedayId, setHeadToHeadViewGamedayId] = useState(null);

  useEffect(() => {
    dispatch(league.getSingleRaceH2HV1({ guid: userGuid, leagueId: leagueId }));
  }, [dispatch, userGuid, leagueId]);

  const handleHeadToHeadViewGamedayIdChange = (gamedayId) => {
    setHeadToHeadViewGamedayId(gamedayId);
  };

  const onBack = () => {
    setHeadToHeadViewGamedayId(null);
  };

  return (
    <>
      {headToHeadViewGamedayId ? (
        <RaceweekHeadtoHead
          gamedayId={headToHeadViewGamedayId}
          handleBack={onBack}
        />
      ) : (
        <OverallHeadtoHead
          handleHeadToHeadViewGamedayIdChange={
            handleHeadToHeadViewGamedayIdChange
          }
        />
      )}
    </>
  );
};

export default HeadToHead;
